import { Slot } from '@radix-ui/react-slot'
import { forwardRef } from 'react'
import { cn } from '@scalis/utils'
import { bodyClassName } from './body.styles'
import { BodyProps } from './body.types'

/** @deprecated use typography classes instead, such as
 * `body-large-basic`,
 * `body-large-emphasis`,
 * `body-medium-basic`,
 * `body-medium-emphasis`,
 * `body-medium-underline`,
 * `body-small-basic`,
 * `body-small-emphasis`,
 * `body-small-bold`,
 * `body-small-underline`
 */
export const Body = forwardRef<HTMLParagraphElement, BodyProps>(
  ({ asChild, size, underline, italic, type, center, textAlign, className, style, color, ...props }, ref) => {
    const Comp = asChild ? Slot : 'p'

    return (
      <Comp
        ref={ref}
        style={style}
        className={cn(
          bodyClassName({
            size,
            underline,
            italic,
            type,
            center,
            textAlign,
            color,
          }),
          className,
        )}
        {...props}
      />
    )
  },
)
Body.displayName = 'Body'
